import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-adress-book1-icon',
  templateUrl: './communication-adress-book1.component.html'
})
export class CommunicationAdressBook1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
